module.exports = __webpack_public_path__ + "static/media/feat-modal.9dd56ef8.png";